/**
 * アプリケーション設定（実行時の設定値を管理）
 */

import { Injectable } from '@angular/core';
import { API_CONSTANTS, STORAGE_KEYS } from '../constants';

export interface AppSettings {
  apiBaseUrl: string;
  tokenEnabled: boolean;
  tokenValue: string;
  copySelectionWithHeaders: boolean;
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private settings: AppSettings = {
    apiBaseUrl: API_CONSTANTS.DEFAULT_BASE_URL,
    tokenEnabled: false,
    tokenValue: '',
    copySelectionWithHeaders: false,
  };

  constructor() {
    this.loadFromStorage();
  }

  /** localStorageから設定を復元 */
  private loadFromStorage(): void {
    try {
      const baseUrl = localStorage.getItem(STORAGE_KEYS.API_BASE_URL);
      if (baseUrl) {
        this.settings.apiBaseUrl = baseUrl;
      }
      const tokenEnabled = localStorage.getItem(STORAGE_KEYS.TOKEN_ENABLED);
      if (tokenEnabled !== null) {
        this.settings.tokenEnabled = tokenEnabled === 'true';
      }
      const tokenValue = localStorage.getItem(STORAGE_KEYS.TOKEN_VALUE);
      if (tokenValue !== null) {
        this.settings.tokenValue = tokenValue;
      }
      const copySelectionWithHeaders = localStorage.getItem(STORAGE_KEYS.COPY_SELECTION_WITH_HEADERS);
      if (copySelectionWithHeaders !== null) {
        this.settings.copySelectionWithHeaders = copySelectionWithHeaders === 'true';
      }
    } catch {
      // localStorage アクセス不可時は初期値のまま
    }
  }

  /** 設定を保存 */
  saveSettings(partial: Partial<AppSettings>): void {
    Object.assign(this.settings, partial);
    try {
      localStorage.setItem(STORAGE_KEYS.API_BASE_URL, this.settings.apiBaseUrl);
      localStorage.setItem(STORAGE_KEYS.TOKEN_ENABLED, String(this.settings.tokenEnabled));
      localStorage.setItem(STORAGE_KEYS.TOKEN_VALUE, this.settings.tokenValue);
      localStorage.setItem(
        STORAGE_KEYS.COPY_SELECTION_WITH_HEADERS,
        String(this.settings.copySelectionWithHeaders),
      );
    } catch {
      // localStorage 書き込み失敗時は無視
    }
  }

  get apiBaseUrl(): string {
    return this.settings.apiBaseUrl;
  }

  get tokenEnabled(): boolean {
    return this.settings.tokenEnabled;
  }

  get tokenValue(): string {
    return this.settings.tokenValue;
  }

  get copySelectionWithHeaders(): boolean {
    return this.settings.copySelectionWithHeaders;
  }

  /** 現在の設定のコピーを取得 */
  getSettings(): AppSettings {
    return { ...this.settings };
  }
}
